import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import TransactionCreationForm from "../../Forms/TransactionCreationForm/TransactionCreationForm";

const TransactionHppTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
  handleDelete,
  discountData,
  modalForm,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Detect window size for mobile view
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenEditModal = (id) => {
    const transactionToEdit = data.find(
      (transaction) => transaction._id === id
    );
    if (transactionToEdit) {
      setSelectedTransaction(transactionToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedTransaction(null);
  };

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "OUTLET",
      dataIndex: "counterName",
      key: "counterName",
    },
    {
      title: "Kode Toko",
      dataIndex: "counterCode",
      key: "counterCode",
    },
    {
      title: "TANGGAL",
      dataIndex: "transactionDate",
      key: "transactionDate",
      sorter: true,
      render: (value) => (value ? new Date(value).toLocaleDateString() : "N/A"),
    },
    {
      title: "NOBON",
      dataIndex: "noBon",
      key: "noBon",
      sorter: true,
    },
    {
      title: "barcode",
      dataIndex: "barcode",
      key: "barcode",
      sorter: true,
    },
    {
      title: "kategori",
      dataIndex: ["articleDetails", "category"],
      key: "category",
      sorter: true,
    },
    {
      title: "BARANG",
      dataIndex: "article",
      key: "article",
    },
    {
      title: "size",
      dataIndex: "size",
      key: "size",
      sorter: true,
    },
    {
      title: "DivKecil",
      dataIndex: ["articleDetails", "division"],
      key: "division",
      sorter: true,
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "quantity",
      sorter: true,
    },
    {
      title: "HPP",
      dataIndex: "hpp",
      key: "hpp",
      sorter: true,
      render: (value) => (value ? "Rp " + value.toLocaleString() : "Rp 0"),
    },
    {
      title: "HJUAL",
      dataIndex: "price",
      key: "price",
      sorter: true,
      render: (value) => "Rp " + value?.toLocaleString() || "0",
    },
    {
      title: "TOTAL",
      dataIndex: "totalBeforeDisc",
      key: "totalBeforeDisc",
      render: (value) => (value ? "Rp " + value.toLocaleString() : "Rp 0"),
    },
    {
      title: "DISC1",
      dataIndex: "discount",
      key: "discount",
      sorter: true,
      render: (value) => (value ? value + "%" : ""),
    },
    {
      title: "NETVAL",
      dataIndex: "total",
      key: "total",
      sorter: true,
      render: (value) => "Rp " + value?.toLocaleString() || "0",
    },
  ];

  return (
    <div style={{ width: "80vw" }}>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          onChange={handleTableOnChange}
          rowKey="_id"
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }} // Enables horizontal scrolling if needed
        />
      </Spin>
      <Modal
        title="Edit Transaction"
        open={isEditModalVisible}
        onCancel={handleCloseEditModal}
        footer={null}
      >
        {selectedTransaction && (
          <TransactionCreationForm
            transactionData={selectedTransaction}
            onClose={handleCloseEditModal}
            callReFetch={callReFetch}
            discountData={discountData}
            modalForm={modalForm}
            callReFetchTransaction={callReFetch}
            setIsEditModalVisible={setIsEditModalVisible}
            isEditMode
          />
        )}
      </Modal>
    </div>
  );
};

TransactionHppTable.propTypes = {
  history: PropTypes.object,
  loading: PropTypes.bool,
  data: PropTypes.array,
  callReFetch: PropTypes.func,
  dispatch: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default TransactionHppTable;
